import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fill='#202020'
        fillOpacity='0.5'
        d='M12 12.819L15.89 9 17 10.09 12 15l-5-4.91L8.11 9 12 12.819z'
      ></path>
    </svg>
  )
}

export default Icon
